import config from '@/components/alert/config/storage';
import message from '@/components/alert/message/storage';

export default {
    namespaced: true,
    modules: {
        config,
        message,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}